import { ListWrapper } from "./style";

const FeaturesList = ({children}: any) => (
  <ListWrapper>
    {children}
  </ListWrapper>
);

export default FeaturesList;